/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import React from 'react';
import styled from 'styled-components';

import { DropdownItem, DropdownItemCheck, DropdownItemCheckList, DropdownToggleIcon } from 'nmqf-common-ui';
import { DropdownMenu, UncontrolledDropdown } from 'reactstrap';

export const ILLINOIS_REGIONS = ['Bellwood', 'Champaign', 'Edwardsville', 'Marion', 'Peoria', 'Rockford', 'West Chicago'];

const StyledSubMenuItem = styled(UncontrolledDropdown)`
  cursor: pointer;
  display: flex;
  padding-right: 0;
`;
const RegionSelectItem = styled.div`
  cursor: pointer;
`;

interface DataRegionOverlayProps {
  value?: string[];
  onChange: (v?: string[]) => void;
}

export const DataRegionOverlay: React.FC<DataRegionOverlayProps> = (props) => {
  const checked = !!props.value?.length;

  const handleClickRegion = () => {
    props.onChange(checked ? undefined : ILLINOIS_REGIONS);
  };

  return (
    <>
      <DropdownItem header>Overlays</DropdownItem>
      <DropdownItemCheck
        toggle={false}
        tag={StyledSubMenuItem}
        direction="right"
        checked={checked}
        partial={props.value?.length !== ILLINOIS_REGIONS.length}
        onChange={handleClickRegion}
      >
        <span className="flex-grow-1">Illinois Region</span>
        <DropdownToggleIcon disabled={false} onClick={(event: any) => event.stopPropagation()} caret color="warning" className="py-0" />
        <DropdownMenu onClick={(event: any) => event.stopPropagation()}>
          {ILLINOIS_REGIONS.map((region) => (
            <DropdownItemCheckList
              values={props.value}
              onChange={props.onChange}
              value={region}
              key={region}
              tag={RegionSelectItem}
              toggle={false}
              label={region}
            />
          ))}
        </DropdownMenu>
      </DropdownItemCheck>
    </>
  );
};
